export default __webpack_public_path__ + "static/header-iconic-link-solutions-icon7.url-d7694b20d70831e385fff5e913e0cc28.svg";